// Review Schema for AI Search Engines
export const createReviewSchema = (reviews: Array<{
  author: string;
  rating: number;
  text: string;
  date: string;
  platform: string;
}>) => ({
  '@context': 'https://schema.org',
  '@type': 'Organization',
  '@id': 'https://colorado-plumbing.com/',
  'name': 'Colorado First Plumbing and Sewer LLC',
  'aggregateRating': {
    '@type': 'AggregateRating',
    'ratingValue': '4.8',
    'reviewCount': '360',
    'bestRating': '5',
    'worstRating': '1'
  },
  'review': reviews.map(review => ({
    '@type': 'Review',
    'author': {
      '@type': 'Person',
      'name': review.author
    },
    'datePublished': review.date,
    'reviewBody': review.text,
    'reviewRating': {
      '@type': 'Rating',
      'ratingValue': review.rating,
      'bestRating': '5'
    },
    'publisher': {
      '@type': 'Organization',
      'name': review.platform
    }
  }))
});

// Service Schema for AI Understanding
export const createServiceSchema = (serviceName: string, description: string) => ({
  '@context': 'https://schema.org',
  '@type': 'Service',
  'name': serviceName,
  'description': description,
  'provider': {
    '@id': 'https://colorado-plumbing.com/'
  },
  'areaServed': {
    '@type': 'State', 
    'name': 'Colorado'
  },
  'offers': {
    '@type': 'Offer',
    'priceCurrency': 'USD',
    'availability': 'https://schema.org/InStock'
  }
});
